/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Agenda_Filter_CountInputs */



/**
* | output |
* | --- |
* | "{count} types" |
*
* @param {Agenda_Filter_CountInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_filter_count = /** @type {((inputs: Agenda_Filter_CountInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Filter_CountInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.count} types`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} types`)
	return /** @type {LocalizedString} */ (`${i?.count} types`)
});